import React from 'react';
import './PolicyPage.css'; // Link to your custom CSS file

const PolicyPage = () => {
  return (
    <div className="policy-container">
      <div className="policy-content">
        <h1>Conditions d'utilisation & Politique de confidentialité</h1>

        <p>
          En réservant un trajet via notre site, vous acceptez les termes suivants relatifs à la
          collecte, l'utilisation et la sécurité des données personnelles.
        </p>

        <h3>Collecte des données</h3>
        <p>Nous collectons les informations suivantes pour traiter votre réservation :</p>
        <ul>
          <li>Nom et prénom</li>
          <li>Coordonnées (email et téléphone)</li>
          <li>Adresse de départ et de destination</li>
          <li>Informations sur votre vol ou train (le cas échéant)</li>
          <li>Nombre de passagers et de valises</li>
          <li>Message ou instructions supplémentaires (optionnel)</li>
        </ul>

        <h3>Base légale du traitement</h3>
        <p>
          Le traitement de vos données repose sur l'exécution d'un contrat (votre réservation) et votre consentement pour les informations facultatives.
        </p>

        <h3>Utilisation des données</h3>
        <p>
          Les informations collectées sont utilisées exclusivement pour gérer votre réservation,
          adapter notre service à vos besoins, et vous contacter en cas de besoin.
        </p>

        <h3>Durée de conservation</h3>
        <p>
          Vos données sont conservées uniquement pendant la durée nécessaire au traitement de votre
          demande, puis archivées ou supprimées conformément aux obligations légales.
        </p>

        <h3>Partage des données</h3>
        <p>
          Vos données ne sont jamais partagées à des fins commerciales. Nous utilisons un service
          tiers, <strong>EmailJS</strong>, pour transmettre vos informations de réservation de manière
          sécurisée. Ce prestataire est conforme au RGPD.
        </p>

        <h3>Sécurité des données</h3>
        <p>
          Nous mettons en œuvre des mesures techniques et organisationnelles pour protéger vos
          données personnelles contre tout accès, altération ou divulgation non autorisée.
        </p>

        <h3>Vos droits</h3>
        <p>
          Conformément au Règlement Général sur la Protection des Données (RGPD), vous avez le droit :
        </p>
        <ul>
          <li>d’accéder à vos données</li>
          <li>de les rectifier</li>
          <li>de demander leur suppression</li>
          <li>de limiter leur traitement</li>
          <li>de retirer votre consentement à tout moment</li>
          <li>d’introduire une réclamation auprès de la CNIL</li>
        </ul>
        <p>
          Nous n'utilisons pas de cookies sur ce site web. Les informations que vous fournissez (nom, e-mail, date, heure et service sélectionné) sont uniquement utilisées pour planifier et assurer votre service de chauffeur VTC, conformément au Règlement Général sur la Protection des Données (RGPD).
        </p>
        <p>
          Pour exercer vos droits, contactez-nous à : <a href="mailto:Revierradriver@gmail.com">Revierradriver@gmail.com</a>
        </p>

        <h3>Consentement</h3>
        <p>
          En soumettant vos informations via notre formulaire, vous consentez expressément à leur
          traitement tel que décrit dans cette politique.
        </p>

        <div className="text-center">
          <a href="/" className="cta-button">Retour à la réservation</a>
        </div>
      </div>
    </div>
  );
};

export default PolicyPage;
